import styled, { css } from 'styled-components';

export const InputWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-color: ${theme.v2.colors.feedback.canceledPure};
    border-radius: 0px;
    border-style: solid;
    border-width: 0px 0px 1px 0px;
    display: flex;
    min-width: 237px;

    fieldset {
      border: 0px !important;
    }

    input {
      padding: 8px;
      color: ${theme.v2.colors.neutral.lowDark};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      line-height: ${theme.v2.font.lineHeight.text};
    }
  `}
`;

export const SearchIconWrapper = styled.div``;
